import qs from 'qs'
import apiClient from '../client'

const getLocations = queryParams => {
  const client = apiClient(process.env.REACT_APP_NESTREADY_SEARCH_API_URL)
  const paramString = qs.stringify(queryParams)
  return client.get(`locations/usa?${paramString}`)
}

export { getLocations }
